import styled from '@emotion/styled'
export const StyleAuthHeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  column-gap: 5px;
  row-gap: 5px;
  flex-direction: column;
`

export const StyleTitle = styled.p`
  font-size: 21px;
  color: ${(props: any) => props.theme.colors.text};
  font-weight: 400;
`

export const StyleTag = styled.span`
  font-size: 21px;
  color: ${(props: any) => props.theme.colors.primary};
  font-weight: 400;
`

export const StyleSubTitle = styled.p`
  font-size: 16px;
  color: ${(props: any) => props.theme.colors.secondary};
  font-weight: 400;
`
